"use strict";

var _interopRequireDefault = require("D:/G/YT/mes-project-web/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.addConfig = addConfig;
exports.delConfig = delConfig;
exports.exportConfig = exportConfig;
exports.getConfig = getConfig;
exports.getConfigKey = getConfigKey;
exports.getSysConfig = getSysConfig;
exports.listConfig = listConfig;
exports.selectCaptchaEnabled = selectCaptchaEnabled;
exports.selectPasswordCheckEnabled = selectPasswordCheckEnabled;
exports.selectRegisterEnabled = selectRegisterEnabled;
exports.selectSmsLoginEnabled = selectSmsLoginEnabled;
exports.updateConfig = updateConfig;
var _request = _interopRequireDefault(require("@/utils/request"));
var _cloud = require("@/utils/cloud");
// 查询参数列表
function listConfig(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/list',
    method: 'get',
    params: query
  });
}

// 查询参数详细
function getConfig(configId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/' + configId,
    method: 'get'
  });
}

// 根据参数键名查询参数值
function getConfigKey(configKey) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/configKey/' + configKey,
    method: 'get'
  });
}

// 新增参数配置
function addConfig(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config',
    method: 'post',
    data: data
  });
}

// 修改参数配置
function updateConfig(data) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config',
    method: 'put',
    data: data
  });
}

// 删除参数配置
function delConfig(configId) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/' + configId,
    method: 'delete'
  });
}

// 导出参数
function exportConfig(query) {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/export',
    method: 'get',
    params: query
  });
}

// 获取登陆验证码开关
function selectCaptchaEnabled() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/selectCaptchaEnabled',
    method: 'get'
  });
}

// 获取密码强制校验开关
function selectPasswordCheckEnabled() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/selectPasswordCheckEnabled',
    method: 'get'
  });
}

// 获取注册验证码开关
function selectRegisterEnabled() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/selectRegisterEnabled',
    method: 'get'
  });
}

// 获取启用短信登陆
function selectSmsLoginEnabled() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/selectSmsLoginEnabled',
    method: 'get'
  });
}

// 获取系统配置
function getSysConfig() {
  return (0, _request.default)({
    url: _cloud.urls.user + '/system/config/getSysConfig',
    method: 'get'
  });
}